import React, { useEffect, useState } from "react";//added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  channelPartnerList,
  channelPartnerFilter,
  channelPartnerStatusUpdate,
  channelPartnerApprove,
  getAssignCPList
} from "reduxStore/action/channelPartnerAction";
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import { channelPartnerUserType } from "utils/constants";
import usePage from "utils/usePage";
import moment from "moment";
import Select from "react-select";
import Button from "component/Button";
import { cpCurrentMaping } from "../../reduxStore/action/channelPartnerAction";
import AllocateProperty from "../../component/common/AllocateProperty"
import apiEndPoints from "utils/apiEndPoints";
import { apiCall, errorToast, successToast } from "utils/httpClient";

const ChannelPartner = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formState, setFormState] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null); 
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [currentCPMaping, setCurrentCPMaping] = useState([]);
  const [tlList, setTlList] = useState([]);
  const [smList, setSmList] = useState([]);
  const [isApproved, setIsApproved] = useState(false);
  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner
  );
  const cpCurrentMapingSelector =
    useSelector((state) => state?.cpMapingData) || {};

    const permissionSelector = useSelector((state) => state.permission);
    const {  isAdmin = false } = permissionSelector;

    const {response:res} = useSelector((state) => state.login)

    const [modalShow, setModalShow] = useState(false);
    const [selectedCpId, setSelectedCpId] = useState("");
    
      
        const handleAllocateClick = (cp_id) => {
          setModalShow(true); // Show the modal
          setSelectedCpId(cp_id)
        };
      
        
    
        const handleCloseModal = () => {
          
            setModalShow(false);
            setSelectedCpId("")
          };


          const [showModal, setShowModal] = useState(false); // Modal visibility state
          const [selectedItem, setSelectedItem] = useState(null); // Store the selected item for confirmation
        
          // Function to handle the button click (show modal with action)
          const handleButtonClick = (item, action) => {
            setSelectedItem(item); // Set the selected item for confirmation
            setShowModal(true); // Show the modal
          };
        
          // Function to handle confirmation of the action
          const handleConfirm = () => {
            if (selectedItem) {
              activeDeactive(selectedItem._id, selectedItem.active_status ? true : false,selectedItem?.total_visit); // Call the activeDeactive function
              setShowModal(false); // Close the modal
            }
          };
        
          // Function to handle modal cancel
          const handleCancel = () => {
            setShowModal(false); // Close the modal without any action
          };  

          const activeDeactive = async (user_id, active_status,isLead) => {

            if(isLead===0){
            const params = {
              user_id,       // The ID of the user/channel partner
              status: 2,     // Status is always 2 as per your requirement
              active_status  // Current active_status value from the item
            };
          
            try {
              const response = await apiCall("post", apiEndPoints.SMCHANNELPARTNERSTATUS, params);
              if (response?.data?.status === 200) {
                // Handle successful response (e.g., show a success message)
                successToast(response?.data?.message);
                dispatch(
                  getAssignCPList({
                    user_id: res?.data?._id,
                    limit: 10,
                    offset: page,
                    // role_id: roleId,
                  })
                )
                setIsApproved(false)
                // Optionally, trigger a state update to reflect the changes in UI
              } else {
                errorToast(response?.data?.message);
              }
            } catch (error) {
              console.error("Error calling API:", error);
            }
          }else{
            const params = {
              user_id,       // The ID of the user/channel partner   
              active_status  // Current active_status value from the item
            };
          
            try {
              const response = await apiCall("post", apiEndPoints.TRANSFERCHANELPARTNERSTATUS, params);
              if (response?.data?.status === 200) {
                // Handle successful response (e.g., show a success message)
                successToast(response?.data?.message);
                dispatch(
                  getAssignCPList({
                    user_id: res?.data?._id,
                    limit: 10,
                    offset: page,
                    // role_id: roleId,
                  })
                )
                setIsApproved(false)
                // Optionally, trigger a state update to reflect the changes in UI
              } else {
                errorToast(response?.data?.message);
              }
            } catch (error) {
              console.error("Error calling API:", error);
            }
          }
          };

  const params = new URLSearchParams(window.location.search);
  const roleId = params.get("role_id");
  const userType = params.get("user_type")
    ? params.get("user_type")
    : channelPartnerUserType.cp;

  const { create, view,edit } = usePermission({
    create: "add_channelpartner",
    view: "view_channelpartner",
    edit:"edit_channelpartner"
  });
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    cp_name: "",
    limit: "",
    offset: "",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    if(isAdmin){
    dispatch(
      channelPartnerList({
        user_type: userType,
        limit: 10,
        offset: page,
        role_id: roleId,
      })
    );
  }else{
    dispatch(
      getAssignCPList({
        user_id: res?.data?._id,
        limit: 10,
        offset: page,
        // role_id: roleId,
      })
    )
    setIsApproved(false)
  }
  }, [dispatch]);

  useEffect(() => {
    if (cpCurrentMapingSelector.response) {
      const { response } = cpCurrentMapingSelector;
      if (response?.status === 200) {
        setCurrentCPMaping(
          handleListResponse([...response.data, ...response.userdata])
        );
        const tlArrayData = response.data.map((el) => {
          return {
            main_parent_id: el.main_parent_id,
            user_name: el.stl_name[0],
          };
        });
        const tlArrayUserData = response.userdata.map((el) => {
          return {
            main_parent_id: el.parent_id,
            user_name: el.user_name,
            _id: el._id,
          };
        });
        // tlArray.push(...tlArrayUserData)

        const smArray = response.data.map((el) => {
          return {
            _id: el.parent_id,
            user_name: el.sm_name[0],
          };
        });
        const arrayUniqueTL = [
          ...new Map(
            tlArrayData.map((item) => [item["main_parent_id"], item])
          ).values(),
        ];
        setTlList(tlArrayUserData);
        setSmList(smArray);
        setFormState({
          ...formState,
          currentCPMapingTL: arrayUniqueTL,
          currentCPMapingSM: smArray,
        });
      } else {
        setCurrentCPMaping([]);
      }
    }
  }, [cpCurrentMapingSelector]);

  useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;
    if (response && response?.status === 200) {

      if (!create && response.data?.length > 0) {
        setchannelPartnerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      } else {
        if(isAdmin){
        dispatch(
          channelPartnerList({
            user_type: userType,
            limit: 10,
            offset: page,
          })
        );
      }else{
        dispatch(
          getAssignCPList({
            user_id: res?.data?._id,
            limit: 10,
            offset: page,
          })
        );
        setIsApproved(false)
      }
      }
    } else {
      setchannelPartnerList([]);
    }
  }, [channelPartnerListSelector]);

   
  const handleSelectMultiTL = (value) => {
    setFormState({
      ...formState,
      currentCPMapingTL: value,
    });
  };
  const handleSelectMultiSM = (value) => {
    setFormState({
      ...formState,
      currentCPMapingSM: value,
    });
  };

  const handleUserStatus = (data) => {
    dispatch(channelPartnerStatusUpdate(data));
  };

  const filterDetail = () => {
    if (!handleValid()) {
      if(isAdmin){
      dispatch(
        channelPartnerFilter({
          limit: 10,
          offset: 0,
          user_type: userType,
          role_id: roleId,
          start_date: form.start_date,
          end_date: form.end_date,
          cp_name: form.cp_name,
        })
      );
    }else{
      dispatch(
        getAssignCPList({
          user_id: res?.data?._id,
          limit: 10,
          offset: 0,
          startdate: form.start_date,
          enddate: form.end_date,
          search_by_name: form.cp_name,
        })
      );
    }
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      cp_name: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    if(isAdmin){
    dispatch(
      channelPartnerList({
        user_type: userType,
        limit: 10,
        offset: 0,
        role_id: roleId,
      }),
   
    );
  }else{
    dispatch(
      getAssignCPList({
        user_id: res?.data?._id,
        limit: 10,
        offset: 0,
      })
    );
  }
    setPage(0)
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
       setPage(0)
       if(isAdmin){
          dispatch(
            channelPartnerList({
              limit: 10,
              offset: newOffset,
              start_date: form.start_date,
              end_date: form.end_date,
              cp_name: form.cp_name,
              role_id: roleId,
              user_type: userType,
            })
          );
       }else{
        dispatch(
          getAssignCPList({
            user_id: res?.data?._id,
            limit: 10,
            offset: newOffset,
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
       }
  };

  const deactiveCps =()=>{
    setIsApproved(true);
    dispatch(
      getAssignCPList({
        user_id: res?.data?._id,
        status: 1
      })
    )
  }

  const backToCpList = () =>{
    setIsApproved(false)
    dispatch(
      getAssignCPList({
        user_id: res?.data?._id,
        limit: 10,
        offset: page,
        // role_id: roleId,
      })
    )
  }

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Channel Parnter Listing",
      metaDescription: "Channel partner listing",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleApprove = (itemId) => {
    const data = { cp_id: itemId, approved: true }; // Create the object to send
    dispatch(channelPartnerApprove(data)); // Pass data to the action
    setModalOpen(false); // Close modal after approval
  };

  const openApprovalModal = (itemId) => {
    setSelectedItemId(itemId);
    setModalOpen(true); // Open modal when Approve button is clicked
  };

  return (
    <div className="page-body">
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabe2">
                Allocation
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-body">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.sourcingTL}
                      {/* <span className="required-field"></span> */}
                    </label>
                    <Select
                      isSearchable
                      isMulti
                      options={currentCPMaping || []}
                      getOptionLabel={(option) => option.user_name}
                      getOptionValue={(option) => option._id}
                      name="currentCPMapingTL"
                      value={formState.currentCPMapingTL}
                      onChange={handleSelectMultiTL}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.sourcingManager}
                    </label>
                    <Select
                      isSearchable
                      isMulti
                      options={currentCPMaping || []}
                      getOptionLabel={(option) => option.user_name}
                      getOptionValue={(option) => option._id}
                      name="currentCPMapingSM"
                      value={formState.currentCPMapingSM}
                      onChange={handleSelectMultiSM}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center ">
              <button
                className="btn btn-success mr-5"
                type="button"
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
      <Breadcrumb
        title={strings.channelPartner}
        titleactive={strings.channelPartnerListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
          {/* {!isApproved && (
            <> */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="cp_name"
                              value={form.cp_name}
                              onChange={handleInputField}
                              placeholder={strings.searchName}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-12 pt-3">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning  mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {/* </>
          )} */}
            {!isApproved && create && (
              <div className="row pt-3">
                {create &&
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/add_channel_partner")}
                    >
                      {strings.addNewCP}
                    </button>
                  </div>
                </div>
                }
                { !isAdmin &&
                <>
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => deactiveCps()}
                    >
                      {strings.approveNewCp}
                    </button>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/allocateCpToSM")}
                    >
                      {strings.allocateCpToSm}
                    </button>
                  </div>
                </div>
                </>
}
              </div>
              
            )}

{isApproved && (
            <div className="row pt-3 d-flex justify-content-end">
              <div className="col-auto">
                <div className="form-group">
                  <button
                    className="btn btn-color"
                    type="button"
                    onClick={() => backToCpList()} // Go back to initial state
                  >
                    {strings.back}
                  </button>
                </div>
              </div>
            </div>
          )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div  className="card-header">
                    <h5>{isApproved?strings.approveNewCp:strings.listOfChannelPartner}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.cpName}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.agentCode}</th>
                          <th scope="col">{strings.visits}</th>
                          <th scope="col">{strings.noOfSiteVisit}</th>
                          <th scope="col">{strings.noOfClosingLead}</th>
                          <th scope="col">{strings.closingPercentage}</th>
                          {/* <th scope="col">{strings.approved}</th> */}
                          {isAdmin &&
                          <th scope="col">{strings.status}</th>
}
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getchannelPartnerList?.length > 0 ? (
                          getchannelPartnerList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ inlineSize: "130px" }}>
                                  {item?.agent_name}
                                </td>
                                <td>
                                  {item.createdDate
                                    ? moment(item.createdDate).format(
                                      "DD-MM-yyyy hh:mm a"
                                    )
                                    : "-"}
                                </td>
                                <td>{item.agent_code}</td>
                                <td>{item.total_visit}</td>
                                <td>{item.total_site_visit}</td>
                                <td>{item.total_closing_lead}</td>
                                <td>
                                  {item.total_closing_percentage
                                    ? Number(
                                      item.total_closing_percentage.replace(
                                        "%",
                                        ""
                                      )
                                    ).toFixed(2) + "%"
                                    : "-"}
                                </td>
                                {/* <td>
                                  {item.approved ? (
                                    "Approved"
                                  ) : (
                                    <Button
                                      className="btn btn-success"
                                      onClick={() => openApprovalModal(item._id)} // Pass the ID to approve
                                      label="Approve"
                                      style={{ padding: '5px 10px', minWidth: 'auto' }} // Adjust padding for horizontal size
                                    />
                                  )}
                                </td> */}
                                 {isAdmin &&
                                <td className="switchmain">
                                  {/* {item.approved ? ( // Check if the item is approved */}
                                    {item.status ? (
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={true}
                                          onChange={(e) => {
                                            handleUserStatus({
                                              cp_id: item._id,
                                              status: 2,
                                               login_id: item?.login_id
                                            });
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    ) : (
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={false}
                                          onChange={(e) => {
                                            handleUserStatus({
                                              cp_id: item._id,
                                              status: 1,
                                               login_id: item?.login_id
                                            });
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    )}
                                  {/* ) : (
                                    // If not approved, show a message instead of the switch
                                    <span style={{ color: "grey" }}></span>
                                  )} */}
                                </td>
                                }
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.viewChannelPartner}
                                      onClick={() => {

                                        const navigateTo = isAdmin ? `/viewchannelpartner/${item._id}` : `/viewchannelpartner/${item.cp_id}`;
                                        navigatpage(navigateTo); 
                                      
                                      }}
                                    ></i>
                                  )}
                                  {edit && !isAdmin && (
                                    <i
                                      className="fa fa-edit theme-fa-icon "
                                      aria-hidden="true"
                                      title={strings.editVisitor}
                                      onClick={() => {
                                        navigatpage(
                                          `/add_channel_partner?cp_id=${item.cp_id}`
                                        );
                                      }}
                                    ></i>
                                  )}
                                   {edit && !isAdmin && (
                                    <>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm fs-6"
                                        onClick={() => handleAllocateClick(item?._id)}
                                        style={{ marginLeft: "10px", maxWidth: "150px", whiteSpace: "nowrap", overflow: "hidden" }} 
                                      >
                                        Allocate Property
                                      </button>

                                   {modalShow && selectedCpId === item?._id &&
                                     <AllocateProperty
                                     show={modalShow}
                                     cp_id={selectedCpId}
                                     handleClose={handleCloseModal}
                                   />
                          }
                                    </>
                                  )}
                                 {edit && !isAdmin && (
                                  <button
                                    type="button"
                                    onClick={() => handleButtonClick(item)}
                                    className="btn-sm mt-1"
                                    style={{
                                      color: item?.active_status ? "red" : "green", // Green for active, red for deactivated
                                      borderColor: item?.active_status ? "red" : "green", // Same logic for border color
                                      backgroundColor: "white",
                                      display: "block"
                                    }}
                                  >
                                    {item?.active_status ? "Deactivate" : "Activate"}
                                  </button>
                                )}


                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                      {/* <i
                                    className="fa fa-edit theme-fa-icon"
                                    aria-hidden="true"
                                    data-toggle="modal"
                                    data-original-title="test"
                                    data-target="#exampleModal1"
                                    title="Allocation"
                                    onClick={() => {
                                      dispatch(
                                        cpCurrentMaping({
                                          agency_id: item?.login_id,
                                        })
                                      );
                                    }}
                                  ></i> */}
                    </table>
                    <TableDataNotFound data={getchannelPartnerList} />
                  </div>
                  <Pagination
                    totalCount={
                      isAdmin?channelPartnerListSelector?.response?.total_data:channelPartnerListSelector?.response?.data_total
                    }
                    listData={getchannelPartnerList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: 'block', backdropFilter: 'blur(5px)' }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="approveModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="approveModalLabel">Confirm Approval</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>Are you sure you want to approve this agent?</h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
              <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => handleApprove(selectedItemId)}
                  data-dismiss="modal"
                >
                  Approve
                </button>
                <button
                  className="btn btn-primary "
                  type="button"
                  onClick={() => setModalOpen(false)}
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{showModal && (
        <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
          backdropFilter: "blur(5px)", // Background blur effect
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
          }}
        >
            <div className="modal-content">
<div className="modal-header">
              <h5 className="modal-title">Confirm Action</h5>
              <button type="button" className="close" onClick={handleCancel}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to {selectedItem.active_status?"Deactivate":"Activate"} the channel partner?
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirm}
              >
                Confirm
              </button>
            </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ChannelPartner;
